$(function () {
    product_slider_2()
})

$(document).on('shopify:section:load', function () {
    product_slider_2()
});

$(document).on('shopify:section:unload', function () {
    product_slider_2()
});

$(document).on('shopify:section:select', function () {
    product_slider_2()
});

$(document).on('shopify:section:deselect', function () {
    product_slider_2()
});

$(document).on('shopify:block:select', function () {
    product_slider_2()
});

$(document).on('shopify:block:deselect', function () {
    product_slider_2()
});

$(document).on('shopify:block:select', function () {
    product_slider_2()
});

function product_slider_2() {
    var swiperr = new Swiper("#shopify-section-nh_text_with_products_f7Vx4a .u_twp_product_row", {
        autoHeight: true,
        calculateHeight: false,
        slidesPerView: 1,
        slideToClickedSlide: false,
        spaceBetween: 16,
        loop: true,
        // scrollbar: {
        //     el: ".u_swiper_scrollbar",
        //     dragSize: 'auto',
        //     draggable: true,
        // },
        // pagination: {
        //     el: '.swiper-pagination',
        //     clickable: true,
        // },
        breakpoints: {
            1500: {
                spaceBetween: 35,
                slidesPerView: 2.4,
            },
            1200: {
                spaceBetween: 28,
                slidesPerView: 2.2,
            },
            990: {
                spaceBetween: 24,
                slidesPerView: 1.6,
            },
            750: {
                spaceBetween: 24,
                slidesPerView: 1.7,
            },
            550: {
                spaceBetween: 24,
                slidesPerView: 1.5,
            },
            430: {
                spaceBetween: 20,
                slidesPerView: 1.2,
            },
            380: {
                spaceBetween: 16,
                slidesPerView: 1.2,
            },
            360: {
                spaceBetween: 16,
                slidesPerView: 1.1,
            }
        }
    });
}